import { React, useEffect, useState } from 'react';

import {
  Dialog,
  TextInputField,
  FormField,
  Button,
  Pane,
  Menu,
  Popover,
  ChevronDownIcon,
  SelectField,
} from 'evergreen-ui';
import { Container, Row, Col } from 'react-grid-system';

import { mutate } from 'swr';
import { useForm } from 'react-hook-form';

import { toastNotification } from '../../../shared/toastNotification';
import { putDreGroupingItem } from '../../../services/api/dreGroupingService';

import {
  dreClassificationInputArray,
  dreClassificationOutputArray,
  inputValidation,
} from '../../../helpers/formHelper';

function DreGroupingEditFormComponent({ isShown, setIsShown, dreGroup = {} }) {
  const companyId = localStorage.getItem('companyId');
  const [isDisabled, setIsDisabled] = useState(true);

  /* Form */

  const { formState, register, handleSubmit, reset, setValue, watch } =
    useForm({
      defaultValues: dreGroup,
    });

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
    inputValidation(watch('name'), watch('isInput'), setIsDisabled);
  }, [watch('isInput'), watch('name')]);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
    reset(dreGroup);
  }, [isShown]);

  const dreGroupingFormFooter = () => {
    return (
      <Pane>
        <Button
          form="dreGrouping-form"
          type="submit"
          width="fit-content"
          id="onSubmit"
          disabled={isDisabled}
        >
          Salvar
        </Button>
      </Pane>
    );
  };

  const onSubmit = (dreGroup) => {
    console.log('onSubmit', dreGroup);
    let statusResponse = false;
    let toastContent = '';

    let dreGroupToUpdate = {
      id: dreGroup.id,
      name: dreGroup.name,
      dreClassification: dreGroup.dreClassification,
    };

    putDreGroupingItem(dreGroupToUpdate)
      .then((res) => {
        console.log('res put dreGrouping: ', res);
        mutate(`dreGrouping-${companyId}`);
        // Also mutate accountPlans since they depend on dreGrouping
        mutate(`accountPlans-${companyId}`);
        statusResponse = 'success';
        toastContent = 'Edição salva.';
        onClose();
      })
      .catch((err) => {
        console.log('put err', err);
        statusResponse = 'warning';
        toastContent = `Erro. Verifique os campos novamente.`;
      })
      .finally(() => {
        toastNotification(statusResponse, toastContent);
      });
  };

  const onClose = () => {
    console.log('onClose function');
    reset();
    setIsShown(false);
  };

  return (
    <Dialog
      isShown={isShown}
      title="Editar Agrupamento"
      onCloseComplete={onClose}
      confirmLabel="Custom Label"
      hasFooter={true}
      footer={dreGroupingFormFooter}
      shouldCloseOnEscapePress={!formState.isDirty}
      width={800}
      backgroundColor="#f8f8f8"
    >
      <div>
        <form id="dreGrouping-form" onSubmit={handleSubmit(onSubmit)}>
          <FormField>
            <Container
              fluid={true}
              style={{
                width: '100%',
                margin: 'none',
                padding: 'none',
              }}
            >
              <Row>
                <Col sm={12} md={12} lg={6}>
                  <TextInputField
                    {...register('name')}
                    label="Agrupamento"
                    id="name"
                    name="name"
                    type="text"
                  />
                </Col>
                <Col sm={12} md={12} lg={6}>
                  <SelectField
                    {...register('dreClassification')}
                    label="Classificação na DRE"
                    onChange={(e) => setValue('dreClassification', e.target.value)}
                  >
                    {watch('isInput') === undefined ? (
                      <option value=""></option>
                    ) : watch('isInput') ? (
                      dreClassificationInputArray.map((item, index) => {
                        return (
                          <option key={index} value={item}>
                            {item}
                          </option>
                        );
                      })
                    ) : (
                      dreClassificationOutputArray.map((item, index) => {
                        return (
                          <option key={index} value={item}>
                            {item}
                          </option>
                        );
                      })
                    )}
                  </SelectField>
                </Col>
              </Row>
              <Row>
                <Col>
                  <Popover
                    content={
                      <Menu
                        {...register('isInput', {
                          value: null,
                        })}
                      >
                        <Menu.Group>
                          <Menu.Item
                            onSelect={() => {
                              setValue('isInput', true);
                            }}
                          >
                            Entrada
                          </Menu.Item>
                          <Menu.Item
                            onSelect={() => {
                              setValue('isInput', false);
                            }}
                          >
                            Saída
                          </Menu.Item>
                        </Menu.Group>
                      </Menu>
                    }
                  >
                    <Button
                      marginRight={15}
                      id="categoryType"
                      type="button"
                      iconAfter={ChevronDownIcon}
                      disabled={true}
                    >
                      {watch('isInput') ? 'Entrada' : 'Saída'}
                    </Button>
                  </Popover>
                </Col>
              </Row>
            </Container>
          </FormField>
        </form>
      </div>
    </Dialog>
  );
}

export default DreGroupingEditFormComponent;
